import LoginPhone from "./-loginPhone";
import { getSystemDefaultPath, isSuperAdminUser } from "@/stores/authStore";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/system/loginPhone")({
  beforeLoad: () => {
    if (!isSuperAdminUser()) {
      throw redirect({ to: getSystemDefaultPath() });
    }
  },
  staticData: {
    menuLabel: "账号管理",
    showInMenu: true,
    menuGroup: "/system",
    menuOrder: 5,
    requireSuperAdmin: true,
  },
  component: LoginPhone,
});
